export function InvalidPatchOperationError(message)
{
    Error.call(this);

    this.name = this.constructor.name;
    this.message = message;

    if( typeof Error.captureStackTrace === 'function' )
        Error.captureStackTrace(this, this.constructor);
}

InvalidPatchOperationError.prototype = Object.create(Error.prototype);
InvalidPatchOperationError.prototype.constructor = InvalidPatchOperationError;
